import { isUserLicensed } from '@bb/users';
import type { AuthContextUser } from 'contexts';
import isAssumeOrgType from './isAssumeOrgType';
import { isBrokerBayAdminEmail } from './isBrokerBayAdminEmail';

/**
 * Following users must still be able to interact with all of the brokerbay features:
 *    1. The auto-generated BB admin
 *    2. The MLS staff and answering service user
 *    3. The MLS staff and answering service user that assumed a licensed agent
 */
const isFullAccessUser = (
  auth: Pick<
    AuthContextUser,
    'email' | 'org' | 'assumerIdMlsStaff' | 'licenseType'
  >,
) => (
    isBrokerBayAdminEmail(auth.email) ||
    isAssumeOrgType(auth.org.type) ||
    (auth.assumerIdMlsStaff && isUserLicensed(auth))
  );

export default isFullAccessUser;
